//formular pro objednani zakaznika
export const ZAKAZNIK_ORDER_FORM = 'ZAKAZNIK_ORDER_FORM';